<template>
  <div>
    {{ formattedComposition }}
    <!-- <p>{{ formattedComposition }}</p> -->
  </div>
</template>

<script>
export default {
  name: "Composition",
  props: {
    composition: Array,
  },
  computed: {
    formattedComposition() {
      let string = [];
      for (let i = 0; i < this.composition.length; i++) {
        for (const [key, value] of Object.entries(this.composition[i])) {
          if (value == "") {
            string += `${key}`;
          }
          if (value != "") {
            string += `${value}% ${key}`;
          }
          if (i != this.composition.length - 1) {
            string += `, `;
          }
        }
      }
      return string;
    },
  },
  data: () => ({}),
  methods: {},
};
</script>
